export default __webpack_public_path__ + "static/media/arrow-right-dark.f3a7d57f.svg";